module.exports = {
      id: "action-usage",
      viewBox: "0 0 22.626 18.6",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#action",
      toString: function () {
        return this.url;
      }
    }